import {useMutation} from "@tanstack/react-query"
import {deleteAccount} from "api/account.api"
import {useAuth} from "context/AuthContext"
import {useToast} from "hooks"
import {useState} from "react"
import {useNavigate} from "react-router-dom"
import styled from "styled-components"
import {ButtonPrimary} from "ui/base/Button/ButtonStyled"
import {Modal} from "ui/base/modal/Modal"
import {ExclamationIcon} from "ui/icons"
import {defaultThemeColors, fonts, mediaSizes, themeFontSize} from "ui/theme"

export const DeleteModal = () => {
    const {logout} = useAuth()
    const navigate = useNavigate()

    const [open, setOpen] = useState(false)
    const handleClose = () => setOpen(false)

    const {mutate} = useMutation({
        mutationFn: deleteAccount,
        onSuccess: (data) => {
            navigate("/")
            logout()
            useToast("success", "Account has been successfully deleted")
        },
        onError: (error) => {
            useToast(
                "error",
                error?.response?.data?.message || "Error: deleteAccount"
            )
        },
    })

    return (
        <>
            <DeleteButton onClick={() => setOpen(true)}>Delete account</DeleteButton>
            <Modal
                show={open}
                handleClose={handleClose}
                minHeight={200}
                maxWidth={450}>
                <Container>
                    <div>
                        <ExclamationIcon/>
                    </div>
                    <Message>
                        Are you sure you want to delete <br/> your account?
                    </Message>
                    <ButtonContainer>
                        <ButtonPrimary variant='primary_fade' onClick={mutate}>Delete</ButtonPrimary>
                        <ButtonPrimary
                            onClick={handleClose}
                            bgColor='white'
                            hasBorder
                            color='blue'>
                            Cancel
                        </ButtonPrimary>
                    </ButtonContainer>
                </Container>
            </Modal>
        </>
    )
}

const Container = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 2rem;
    font-family: Montserrat;
`

const Message = styled.p`

    font-size: ${themeFontSize("regular")};
    font-weight: 600;
    text-align: center;
`

const ButtonContainer = styled.div`
    grid-template-columns: 1fr 1fr;
    display: grid;
    gap: 0.5rem;
    width: 100%;
    justify-content: center;
    align-items: center;
`

const DeleteButton = styled.button`
    all: unset;
    cursor: pointer;
    font-weight: 600;
    text-align: left;
    font-size: ${fonts.sizes.small};

    &:hover {
        text-decoration: underline;
        color: ${defaultThemeColors.pink};
    }

    @media (width >= ${mediaSizes.md}) {
        font-size: ${fonts.sizes.regular};
    }

    @media (width >= ${mediaSizes.lg}) {
        font-size: ${fonts.sizes.medium};
    }
`